<template>
  <div class="seatline height20">
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
    };
  },
  created() {
  }
};
</script>



